<template>
  <div v-wechat-title="titleTop">
    <div class="topAd">
      <van-swipe :autoplay="3000">
        <van-swipe-item><img src="https://res.diveboss.net/activity/cooldive20220223/mermaid0.jpg"></van-swipe-item>
        <van-swipe-item><img src="https://res.diveboss.net/activity/cooldive20220223/mermaid1.jpg"></van-swipe-item>
        <van-swipe-item><img src="https://res.diveboss.net/activity/cooldive20220223/mermaid2.jpg"></van-swipe-item>
      </van-swipe>
    </div>
    <div class="dataRect">
      <div class="topAbout">
        感谢您参与<b>寻找美人鱼计划</b>,请完善下列信息以便于我们预约课程.
        <div v-if="isDisabled" :style="'color:'+GetColorMain()">当前信息已锁定,无法进行修改!</div>
        <div v-if="data.isSandbox" :style="'color:'+GetColorMain()">当前为测试模式，仅用于功能演示!</div>
      </div>
      <div class="line">
        <van-field
          v-model="data.loaclName"
          clearable
          label="姓名"
          placeholder="请输入姓名"
          required
          :disabled="isDisabled"
          @blur="onLocalNameChange"
        />
        <van-field
          v-model="data.lastName"
          clearable
          label="英文姓"
          placeholder="请输入英文姓"
          required
          :disabled="isDisabled"
        />
        <van-field
          v-model="data.firstName"
          clearable
          label="英文名"
          placeholder="请输入英文名"
          required
          :disabled="isDisabled"
        />
        <van-field
          v-model="data.phone"
          clearable
          label="手机号码"
          placeholder="请输入手机号码"
          required
          :disabled="isDisabled"
        />
        <van-field
          v-model="data.idCardNumber"
          clearable
          label="身份证号码"
          placeholder="请输入身份证号码"
          required
          :disabled="isDisabled"
        />
        <!-- <van-field
          v-model="data.passportNumber"
          clearable
          label="护照号码"
          placeholder="请输入护照号码(2选1)"
          :disabled="isDisabled"
        /> -->

        <van-field
          v-model="courseDate"
          clearable
          label="开课日期"
          readonly
          placeholder="请选择开课日期"
          @click="showCourseDate=true"
        />
        <FieldSelect v-model="course" :list="diveCourseList" label="课程" placeholder="请选择课程" @change="onCourseChange" />
      </div>
    </div>
    <div class="emptyRect" />
    <div class="buttonRect"><van-button square :disabled="isDisabled" :loading="buttonLoading" size="large" :color="GetColorMain()" @click="onUpdateCustomerInfo">提交</van-button></div>
    <dateSelect v-model="showCourseDate" :max-date="maxDate" :min-date="minDate" :default-date="courseDate" @onChange="onCourseDateChange" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Swipe, SwipeItem, Dialog } from 'vant'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import dateSelect from '@/components/dateSelect'
import FieldSelect from '@/components/FieldSelect'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Dialog.name]: Dialog,
    dateSelect,
    FieldSelect
  },
  data() {
    return {
      buttonLoading: false,
      data: {},
      hashId: undefined,
      isDisabled: false,
      diveCourseList: [],
      courseDate: undefined,
      showCourseDate: false,
      maxDate: undefined,
      minDate: undefined,
      course: undefined
    }
  },

  created() {
    this.titleTop = '寻找美人鱼'
    this.hashId = this.$route.params.id
    this.initCourse(() => {
      this.minDate = new Date()
      this.maxDate = new Date()
      this.maxDate = new Date(this.maxDate.setDate(this.maxDate.getDate() + 90))
      this.courseDate = undefined
      this.init()
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initCourse(callback) {
      request({
        url: '/DiveMermaid/getMermailDiveCourse',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        var diveCourseList = []
        response.data.forEach(el => {
          diveCourseList.push({ text: el.v, value: el.k })
        })
        this.diveCourseList = JSON.parse(JSON.stringify(diveCourseList))

        if (callback) {
          callback()
        }
      })
    },
    init() {
      request({
        url: '/DiveMermaid/getMermailUserInfo',
        method: 'post',
        params: { id: this.hashId }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.isDisabled = this.data.state !== 'Wait'
        if (this.data.courseStartDate) {
          this.courseDate = formatDate(this.data.courseStartDate, 'yyyy/MM/dd')
        }
        if (this.data.diveCourseId) {
          this.course = this.data.diveCourseId
        }
        if (this.isDisabled) {
          MyNotify('info', '当前信息已锁定,无法进行修改!', 99999999)
        }
      })
    },
    onLocalNameChange() {
      if (this.data.loaclName) {
        this.onGetNamePy(this.data.loaclName, (ln, fn) => {
          this.data.firstName = fn
          this.data.lastName = ln
        })
      }
    },
    onGetNamePy(name, callback) {
      request({
        url: '/User/getNamePySpace',
        method: 'post',
        params: { name: name }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          callback(response.data.lastName, response.data.firstName)
        }
      })
    },
    checkIdCardInfo(idCard, callback) {
      if (!idCard) {
        callback(true)
        return
      }
      idCard = idCard.trim()
      if (idCard.length !== 18) {
        if (callback) {
          callback(false)
        }
        return
      }
      request({
        url: '/User/getUserIdCardInfo',
        method: 'post',
        params: { id: idCard }
      }).then(Response => {
        if (!Response.success) {
          if (callback) {
            callback(false)
          }
          return
        }
        if (!Response.data.isSuccess) {
          if (callback) {
            callback(false)
          }
          return
        }
        if (callback) {
          callback(true)
        }
      })
    },
    onUpdateCustomerInfo() {
      if (!this.data.phone || this.data.phone.length < 11) {
        MyNotify('info', '请输入11位手机号码')
        return false
      }
      if (!this.data.passportNumber && !this.data.idCardNumber) {
        MyNotify('info', '至少输入身份证号码或护照号码其中一个')
        return false
      }
      if (!this.data.loaclName || this.data.loaclName.length < 1) {
        MyNotify('info', '请输入至少2位中文姓名')
        return false
      }
      if (!this.data.lastName || this.data.lastName.length < 1) {
        MyNotify('info', '请输入英文(拼音)姓')
        return false
      }
      if (!this.data.firstName || this.data.firstName.length < 1) {
        MyNotify('info', '请输入英文(拼音)名')
        return false
      }
      if (!this.data.diveCourseId) {
        MyNotify('info', '请选择课程')
        return false
      }
      this.buttonLoading = true
      this.checkIdCardInfo(this.data.idCardNumber, (isSuccess) => {
        if (!isSuccess) {
          this.buttonLoading = false
          MyNotify('info', '请输入正确的18位身份证号码')
          return
        }
        var courseName
        console.log('this.course', this.data.diveCourseId)
        console.log('this.diveCourseList', this.diveCourseList)
        var courseFind = this.diveCourseList.filter(el => el.value === this.data.diveCourseId)
        if (courseFind.length > 0) {
          courseName = courseFind[0].text
        }
        Dialog.confirm({
          title: '请核对信息',
          message: '请核对信息是否准确无误:\r\n' +
         '姓名:' + this.data.loaclName + '\r\n' +
         '英文姓:' + this.data.lastName + '\r\n' +
         '英文名:' + this.data.firstName + '\r\n' +
         '电话号码:' + this.data.phone + '\r\n' +
         '身份证号码:' + (this.data.idCardNumber ? this.data.idCardNumber : '-') + '\r\n' +
         '护照号码:' + (this.data.passportNumber ? this.data.passportNumber : '-') + '\r\n' +
         '开课日期:' + (this.courseDate ? this.courseDate : '待定') + '\r\n' +
         '课程:' + (courseName || '待定')
        }).then(() => {
          this.onUpdateCustomerInfoDo()
        })
          .catch(() => {
            this.buttonLoading = false
          })
      })
    },
    onUpdateCustomerInfoDo() {
      this.buttonLoading = true
      request({
        url: '/DiveMermaid/updateMermailUserInfo',
        method: 'post',
        data: this.data
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '信息提交成功!', 2000)
      })
    },
    onCourseDateChange(date) {
      if (date) {
        this.data.courseStartDate = date
        this.courseDate = formatDate(date, 'yyyy/MM/dd')
      } else {
        this.data.courseStartDate = undefined
        this.courseDate = undefined
      }
    },
    onCourseChange(select) {
      if (select) {
        this.data.diveCourseId = select.value
      } else {
        this.data.diveCourseId = undefined
      }
    }
  }
}
</script>
<style scoped>
.dataRect{
  background-color: #fff;
  padding: 1em;
}
.dataRect .topAbout{
  font-size:0.9em;
  color: #999;
  margin-bottom: 0.5em;
}
.topAd{
  width:100vw;
}
.topAd img{
  width: 100vw;
}
.emptyRect{
  height: 3em;
}
.buttonRect{
  background-color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
